export default "__VITE_ASSET__CFHDUGhK__"